import Intro from "@/components/intro";
import { ARUBA_CONSTANTS } from "./constants";

const ArubaSdn = () => {
  return <Intro {...ARUBA_CONSTANTS} />;
};

export default ArubaSdn;
